import { Attributes } from '@leverege/ui-attributes';
import FilterSourceModel from "../../filters/FilterSourceModel.js";
import FilterSourcesModel from "../../filters/FilterSourcesModel.js";
import Groupings from "../../groupings/Groupings.js";
import FilterUtil from "./FilterUtil.js";
import ResultUtil from "./RequestUtil.js";
/**
 * A Grouping represents information about an arrangement
 * of data associated with the blueprint/device. Normally the
 * grouping object is stored in device.metadata.grouping
 */
export default class GroupingsUtil {
  /** 
   * The blueprint tag indicating that it could have a grouping object
   */
  static TAG = 'has:grouping';
  static findRelationship(rel) {
    if (rel.attribute == null && rel.isItem && rel.blueprint.hasTag(GroupingsUtil.TAG)) {
      return rel;
    }
    let pr = rel.parentRelationship;
    while (pr) {
      if (pr.blueprint.hasTag(GroupingsUtil.TAG)) {
        return pr;
      }
      pr = pr.parentRelationship;
    }
    return null;
  }
  static getSectionStateFromFilters(filters, filterName = ResultUtil.FILTER_NAME) {
    if (filters == null) {
      return null;
    }
    const s = FilterSourcesModel.getSource(filters, filterName);
    return s?.metadata || null;
  }
  static installFilter(opts) {
    const {
      sectionsState,
      relationship,
      currentGrouping,
      onFilterChange,
      filterName,
      isOnMount = false
    } = opts;
    if (onFilterChange == null) {
      return;
    }

    // set values
    let filters = [];
    let hasRootAll = false; // if true, an all exists without filters which means not filters
    const objectType = relationship.objectType;
    const entries = Object.entries(sectionsState || {});
    entries.forEach(([key, value]) => {
      const s = Groupings.getSectionData(currentGrouping, key);
      const v = Groupings.getValueData(currentGrouping, s, value);
      if (s == null || v == null) {
        return;
      }
      const attr = Attributes.getAttribute(s.attributeName, objectType);
      if (attr && attr.blueprint?.field) {
        const field = attr.blueprint.field;
        const fieldType = attr?.fieldType || attr.blueprint.attribute?.searchType || 'string';
        const value = v.value;
        hasRootAll |= s.filter == null && v.filter == null && Groupings.isAll(value);
        const f = FilterUtil.combine(s.filter, FilterUtil.toFilter(v, field, fieldType, objectType));
        if (f) {
          filters.push(f);
        }
      }
    });
    if (hasRootAll) {
      filters = null;
    } else {
      filters = filters.filter(f => f != null);
      if (filters.length > 0) {
        filters = {
          type: 'logical',
          operator: 'or',
          conditions: filters
        };
      } else {
        filters = filters[0] || null;
      }
    }
    let f = FilterSourceModel.setFilter(FilterSourceModel.create(), filters);
    f = FilterSourceModel.setMetadata(f, sectionsState);
    onFilterChange({
      data: filterName,
      value: f,
      isOnMount
    });
  }
}